var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_4338_61639",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.680664H14.8936L20 5.99981L14.8936 11.319H0V0.680664Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.680664V-0.819336H-1.5V0.680664H0ZM14.8936 0.680664L15.9757 -0.358134L15.5329 -0.819336H14.8936V0.680664ZM14.8936 11.319V12.819H15.5329L15.9757 12.3578L14.8936 11.319ZM0 11.319H-1.5V12.819H0V11.319ZM20 5.99981L21.0821 7.03861L22.0793 5.99981L21.0821 4.96102L20 5.99981ZM0 2.18066H14.8936V-0.819336H0V2.18066ZM14.8936 9.81896H0V12.819H14.8936V9.81896ZM1.5 11.319V0.680664H-1.5V11.319H1.5ZM13.8115 1.71946L18.9179 7.03861L21.0821 4.96102L15.9757 -0.358134L13.8115 1.71946ZM18.9179 4.96102L13.8115 10.2802L15.9757 12.3578L21.0821 7.03861L18.9179 4.96102Z",
    fill: "#2B2B35",
    mask: "url(#path-1-inside-1_4338_61639)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockArrow);
export default __webpack_public_path__ + "static/media/block_arrow.a754e5f3c01d7dfc26a4a2c62e02d46a.svg";
export { ForwardRef as ReactComponent };